import React from 'react';

function SectionHeader({ title }) {
  // Color comes from .nav-section-header (violet section label per the
  // style guide) — no inline hex here.
  return (
    <div className='nav-section-header d-flex flex-column justify-content-center'>
      <div>
        { title }
      </div>
    </div>
  );
}

export default SectionHeader;